import { actionTypes } from './index';

export const addNotification = (notification) => ({
  type: actionTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const removeNotification = (notificationId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_NOTIFICATION,
    payload: { notificationId },
  });
};



// WEBPACK FOOTER //
// ./actions/api-notifications.js